import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "contexts/AuthContext";

interface ProtectedRouteProps {
  children: React.ReactElement;
  requiredRole?: "admin" | "employer";
}

const ProtectedRoute = ({ children, requiredRole }: ProtectedRouteProps) => {
  const { isAuthenticated, isVerified, userRole, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  // Check verification status - redirect to verification page if not verified
  // Allow access to verification page itself and auth routes
  // Also check user.account_status as a fallback in case isVerified state is not synced
  const isAuthRoute = location.pathname.startsWith("/auth");
  const userIsVerified = isVerified || (user?.account_status?.id ? true : false);
  
  if (!userIsVerified && !isAuthRoute) {
    return <Navigate to="/auth/email-verification" replace />;
  }

  if (requiredRole && userRole !== requiredRole) {
    // Redirect to appropriate dashboard based on role
    if (userRole === "admin") {
      return <Navigate to="/admin/index" replace />;
    } else if (userRole === "employer") {
      return <Navigate to="/employer/dashboard" replace />;
    }
    return <Navigate to="/auth/login" replace />;
  }

  return children;
};

export default ProtectedRoute;

